import { render, staticRenderFns } from "./VendorManagement.vue?vue&type=template&id=959555f2"
import script from "./VendorManagement.vue?vue&type=script&lang=ts"
export * from "./VendorManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports